import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../../../../services/api";
import HeaderSession from "../../../../../utils/headerSession";
import { useDispatch, useSelector } from "react-redux";
import SearshEstabelecimento from "../../../../../utils/searchEstabelecimento";
import Paginacao from "../../../../../utils/paginacao";
import ListaSolicitacao from "../listaSolicitacao";
import RegisterAccess from "../../../../../utils/registerAccess";
import { SolicitacoesLicenciamentoExcel } from "../../../../exports/gerarelatorioexcel";
import { SolicitacaoLicenciamentoPdf } from "../../../../exports/gerarelatoriopdf";
import {
  DialogActions,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Tooltip,
} from "@mui/material";
import { Download } from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";
import { temPermissao } from "../../../../../utils/permissoes";
import TabelaLoading from "../../../../../load/tabelaLoading";

export default function ChefedodepartamentoArea() {
  const user = useSelector((state) => state.account.user);
  const navigate = useNavigate();
  const [tipo, setTipo] = useState('');
  const [status, setStatus] = useState(''); // novo estado para filtro de status
  const [provincia, setProvincia] = useState('');
  const [estabelecimentos, setEstabelecimentos] = useState("");
  const [perPage, setPerPage] = useState(50);
  const [, setOrder] = useState("");
  const [configLista, setConfigLista] = useState("");
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  // const url = useLocation();

  useEffect(() => {
    setEstabelecimentos("");

    if (
      (user?.funcao === "Chefe de Departamento" ||
        user?.funcao === "Director Geral" ||
        user?.funcao === "CNP") || temPermissao(user, ['licenciamentoEstabelecimentoChefeDepartamento'])
    ) {
    } else {
      dispatch({
        type: "alert",
        payload: { alert: "Acesso negado" },
      });
      navigate("/admin/menu");
    }

    api.get(`/estabelecimentos?page=${page}&status=Analisado Chefe de Secção&perPage=${perPage}}&status=${status}&dataInicio=${dataInicio}&dataFim=${dataFim}&provincia=${provincia}&tipoId=${tipo}`)
      .then((response) => {
        setEstabelecimentos(response.data.estabelecimentos);
        setConfigLista(response.data);
      }).catch((err) => "");

  }, [
    page,
    perPage,
    user?.funcao,
    tipo,
    status,
    provincia,
    user?.seccao,
    navigate,
    dispatch,
    dataInicio,
    dataFim
  ]);

  const [anchorEl, setAnchorEl] = useState(null);
  const Expports = ({ estabelecimentos }) => {
    return (
      <DialogActions>
        <Tooltip title="Opções para Baixar">
          <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
            <Download />
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          <MenuItem
            onClick={() => SolicitacoesLicenciamentoExcel(estabelecimentos)}
          >
            <ListItemIcon>
              <DownloadIcon color="secondary" />
            </ListItemIcon>
            Baixar Excel
          </MenuItem>
          <MenuItem
            onClick={() => SolicitacaoLicenciamentoPdf(estabelecimentos)}
          >
            <ListItemIcon>
              <DownloadIcon color="secondary" />
            </ListItemIcon>
            Baixar PDF
          </MenuItem>
        </Menu>
      </DialogActions>
    );
  };

  return (
    <>
      <RegisterAccess page={"area de chefe de departamento"} />

      <HeaderSession
        title="PROCESSOS ANÁLIZADOS PELA CHEFE DA SECÇÃO"
        actions={true}
        handleExportExcel={() =>
          SolicitacoesLicenciamentoExcel(estabelecimentos)
        }
        handleExportPDF={() => SolicitacaoLicenciamentoPdf(estabelecimentos)}
      />

      <SearshEstabelecimento
        setEstabelecimentos={setEstabelecimentos}
        setTipo={setTipo}
        setStatus={setStatus}
        setProvincia={setProvincia}
        placeholder={"Filtra por nome, número de entrada, data"}
        filtroStatus={false}
        tipo={tipo}
        provincia={provincia}
      />

      {estabelecimentos ? (
        <>
          <ListaSolicitacao
            estabelecimentos={estabelecimentos}
            setEstabelecimentos={setEstabelecimentos}
            tipo={tipo}
            setTipo={setTipo}
            provincia={provincia}
            setProvincia={setProvincia}
            setDataInicio={setDataInicio}
            setDataFim={setDataFim}
            dataInicio={dataInicio}
            dataFim={dataFim}
          >
            <Paginacao
              configLista={configLista}
              lista={estabelecimentos}
              page={page}
              setPage={setPage}
              setPerPage={setPerPage}
              setOrder={setOrder}
            />
          </ListaSolicitacao>
        </>
      ) : (
        <TabelaLoading />
      )}
    </>
  );
}
